import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'

const NotFound = Loadable(lazy(() => import('./NotFound')))
const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')))
const JwtLogin = Loadable(lazy(() => import('./login/JwtLogin')))

const sessionRoutes = [
	{
		path: '/session/signin',
		element: <JwtLogin />
	},
	{
		path: '/session/forgot-password',
		element: <ForgotPassword />
	},
	{
		path: '/session/404',
		element: <NotFound />
	}
]

export default sessionRoutes
